export default __webpack_public_path__ + "static/media/data1.0fea6fbc.jpg";